// extracted by mini-css-extract-plugin
export default {"root":"_39DON","earnings":"_2Xbla","info-icon":"_3bvaL","infoIcon":"_3bvaL"};